import {
	type OrderClaimUpdateDto,
	patchClaimsId,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { orderKeys } from "Order/Api/orderKeys";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

const orderMutationsResource = Resources.base.claim.claimsMutations;

export const useUpdateClaim = (claimId: number, orderId?: number) => {
	const queryClient = useQueryClient();
	const { t } = useResource();
	return useMutation({
		mutationFn: processResponse((data: Partial<OrderClaimUpdateDto>) =>
			patchClaimsId(data, claimId),
		),
		onError: (error) => {
			console.error(`${t(orderMutationsResource.claimUpdateError)}:`, error);
		},
		onSuccess: async () => {
			toast.success(t(orderMutationsResource.claimUpdateSuccess));
			const promises: Promise<unknown>[] = [
				queryClient.invalidateQueries({
					queryKey: orderKeys.claimById(claimId),
				}),
			];
			if (orderId) {
				promises.push(
					queryClient.invalidateQueries({
						queryKey: orderKeys.claimsByOrder(orderId),
					}),
					queryClient.invalidateQueries({
						queryKey: orderKeys.detail(orderId),
					}),
				);
			}
			await Promise.all(promises);
		},
	});
};
